import type { CatalogueEntry } from "../types";
import imageLight from "../images/state-boundaries.light.webp";
import imageDark from "../images/state-boundaries.dark.webp";

export const entry: CatalogueEntry = {
  slug: "state-boundaries",
  displayName: `State Boundaries`,
  datasetProductCode: `STATE BOUNDARIES`,
  subtitle: `Geographic Representation of State and Territory Boundaries.`,
  shortDescription: `State Boundaries is a digital representation of Australia's State and Territory boundaries. This dataset provides an optimised aggregated national view of State and Territory boundary geometry and attribution. The dataset is created from multiple sources including jurisdictional data which is revised regularly and supplied in varying formats and at different levels of quality.`,
  metadata: {
    dateAdded: 1630368000000,
    dataType: ["Polygons"],
    theme: `Administrative Boundaries`,
    totalFeatureCount: 12844,
    updateFrequency: `Quarterly`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/state.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/en/stable/state.html`,
  imageLight,
  imageDark,
  searchTags: `State Boundaries Borders Divisions Geographic Boundaries Jurisdictional Analysis Regional Planning State Borders State Division States`,
  detail: () => import("../details/state-boundaries").then((m) => m.detail),
};

export default entry;
